export default __webpack_public_path__ + "d1c2bc4c87deb4881c70ec395bf1a96c.png";